import { render, staticRenderFns } from "./TabOximetry.vue?vue&type=template&id=74d4db24&scoped=true&"
import script from "./TabOximetry.vue?vue&type=script&lang=js&"
export * from "./TabOximetry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d4db24",
  null
  
)

export default component.exports